import React, { createContext, useState } from "react";

// Issue #63: 管理者専用モーダル(年度更新・Excelアップロード)はDashboard.js内の
// ローカルstateで管理されているが、開くための導線をヘッダーメニューにも追加したい。
// ヘッダーはDashboardのstateへ直接アクセスできないため、「開いてほしいモーダル」を
// 保持するだけの軽量Contextを介して伝える。
// Provider の外で consume された場合(既存テストなど)にクラッシュしないよう、
// no-opのデフォルト値を用意しておく。
const AdminModalContext = createContext({
	pendingAdminModal: null,
	requestAdminModal: () => {},
	clearPendingAdminModal: () => {},
	workingDaysSavedCount: 0,
	notifyWorkingDaysSaved: () => {},
});

export const AdminModalProvider = ({ children }) => {
	const [pendingAdminModal, setPendingAdminModal] = useState(null); // null | "workingDays" | "excel" | "departments"
	// 稼働日数マスタの保存成功をヘッダーの WorkingDaysUnsetAlert へ伝えるカウンタ。
	// 保存で未設定月が解消されてもページ再読み込みまで赤字アラートが残り続ける
	// ことを防ぐため、保存のたびに増分しアラート側の再判定を発火させる。
	const [workingDaysSavedCount, setWorkingDaysSavedCount] = useState(0);

	const requestAdminModal = (modalName) => setPendingAdminModal(modalName);
	const clearPendingAdminModal = () => setPendingAdminModal(null);
	const notifyWorkingDaysSaved = () =>
		setWorkingDaysSavedCount((prev) => prev + 1);

	return (
		<AdminModalContext.Provider
			value={{
				pendingAdminModal,
				requestAdminModal,
				clearPendingAdminModal,
				workingDaysSavedCount,
				notifyWorkingDaysSaved,
			}}
		>
			{children}
		</AdminModalContext.Provider>
	);
};

export default AdminModalContext;
